(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["company-form-styles"] && !Shopify.designMode) return;
  try {
    
(() => {
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function init(root) {
    if (root.dataset.ciReady) return;
    const form = root.querySelector('form');
    if (!form) return;
    root.dataset.ciReady = 'true';

    const status = form.querySelector('.ci-status');
    const button = form.querySelector('.ci-submit');
    const wraps = Array.from(form.querySelectorAll('.ci-field[data-required], .ci-group[data-required]'));

    function setError(wrap, message) {
      wrap.classList.toggle('has-error', !!message);
      const slot = wrap.querySelector('.ci-error');
      if (slot) slot.textContent = message || '';
      const control = wrap.querySelector('input:not([type="radio"]), select, textarea');
      if (control) control.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    function check(wrap) {
      let valid;
      if (wrap.classList.contains('ci-group')) {
        valid = !!wrap.querySelector('input:checked');
      } else {
        const control = wrap.querySelector('input, select, textarea');
        const value = (control.value || '').trim();
        valid = !!value && (!wrap.hasAttribute('data-email') || EMAIL.test(value));
      }
      setError(wrap, valid ? '' : wrap.dataset.error);
      return valid;
    }

    wraps.forEach(wrap => {
      const controls = wrap.querySelectorAll('input, select, textarea');
      controls.forEach(control => {
        control.addEventListener('change', () => { if (wrap.classList.contains('has-error')) check(wrap); });
        control.addEventListener('input', () => { if (wrap.classList.contains('has-error')) check(wrap); });
        if (!wrap.classList.contains('ci-group')) control.addEventListener('blur', () => check(wrap));
      });
    });

    form.addEventListener('submit', event => {
      let firstBad = null;
      wraps.forEach(wrap => {
        if (!check(wrap) && !firstBad) firstBad = wrap;
      });
      if (firstBad) {
        event.preventDefault();
        if (status) status.textContent = 'Please fix the highlighted fields.';
        const target = firstBad.querySelector('input, select, textarea');
        if (target) target.focus({ preventScroll: true });
        firstBad.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      if (status) status.textContent = '';
      if (button) {
        button.disabled = true;
        const label = button.querySelector('span');
        if (label) label.textContent = 'Sending…';
      }
    });
  }

  function initAll(scope) {
    if (scope.matches && scope.matches('.ci-form')) init(scope);
    scope.querySelectorAll('.ci-form').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spike-shields-article"] && !Shopify.designMode) return;
  try {
    
(() => {
  const clean = text => text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();

  function formatHeading(heading, autoSplit) {
    if (heading.dataset.ssSplit || heading.hasAttribute('data-ss-no-split')) return;
    if (heading.querySelector('.ss-heading-subtitle')) return;
    const copy = heading.cloneNode(true);
    copy.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
    const raw = copy.textContent.replace(/\u00a0/g, ' ').trim();
    let match = /\s*\|\s*/.exec(raw);
    if (!match) match = /\s*\n\s*/.exec(raw);
    if (!match && autoSplit) match = /:\s+|\s+[—–-]\s+/.exec(raw);
    if (!match && autoSplit) match = /,\s+(?=and\s+(?:why|how|what|when|where)\b)/i.exec(raw);
    if (!match) return;
    const main = clean(raw.slice(0, match.index));
    const subtitle = clean(raw.slice(match.index + match[0].length));
    if (!main || !subtitle) return;
    if (heading.querySelector('a,img,svg,button,input')) return;
    const first = document.createElement('span');
    const second = document.createElement('span');
    first.className = 'ss-heading-main';
    second.className = 'ss-heading-subtitle';
    first.textContent = main;
    second.textContent = subtitle;
    heading.replaceChildren(first, document.createTextNode(' '), second);
    heading.dataset.ssSplit = 'true';
  }

  function init(root) {
    if (root.dataset.ssReady) return;
    const content = root.querySelector('.ss-content');
    if (!content) return;
    root.dataset.ssReady = 'true';
    const controller = new AbortController();
    const signal = controller.signal;
    let frame = 0;
    let observer;
    root.ssCleanup = () => {
      controller.abort();
      cancelAnimationFrame(frame);
      if (observer) observer.disconnect();
      delete root.dataset.ssReady;
    };
    const rename = (el, tag) => {
      const next = document.createElement(tag);
      Array.from(el.attributes).forEach(a => next.setAttribute(a.name, a.value));
      next.append(...el.childNodes);
      el.replaceWith(next);
      return next;
    };
    const imported = !!content.querySelector('[class*="Mso"],[style*="mso-"],[style*="mso:"]');
    content.querySelectorAll('img').forEach(img => {
      if (!(img.getAttribute('src') || '').trim() && !(img.getAttribute('srcset') || '').trim()) img.hidden = true;
    });
    if (imported) {
      let list = null;
      let listKey = '';
      Array.from(content.children).forEach(el => {
        const style = el.getAttribute('style') || '';
        const marker = el.querySelector('[style*="mso-list: Ignore"],[style*="mso-list:Ignore"]');
        const match = style.match(/mso-list:\s*([^;]+)/i);
        if (el.tagName === 'P' && match && marker) {
          const ordered = /^\s*\d+[.)]/.test(marker.textContent);
          const key = match[1] + (ordered ? 'ol' : 'ul');
          if (!list || key !== listKey || list.nextElementSibling !== el) {
            list = document.createElement(ordered ? 'ol' : 'ul');
            if (ordered) {
              const start = parseInt(marker.textContent, 10);
              if (start > 1) list.start = start;
            }
            el.before(list);
            listKey = key;
          }
          marker.remove();
          const item = document.createElement('li');
          item.append(...el.childNodes);
          list.append(item);
          el.remove();
        } else {
          list = null;
          listKey = '';
        }
      });
      content.querySelectorAll('[style]').forEach(el => el.removeAttribute('style'));
      content.querySelectorAll('table,td,th').forEach(el => {
        ['width','height','cellpadding','cellspacing'].forEach(attr => el.removeAttribute(attr));
      });
      content.querySelectorAll('p,h1,h2,h3,h4,h5,h6').forEach(el => {
        if (!clean(el.textContent) && !el.querySelector('img:not([hidden]),video,iframe,table')) el.remove();
      });
    }
    const first = Array.from(content.children).find(el => clean(el.textContent) || el.querySelector('img[src],img[srcset],video,iframe,table'));
    if (first && first.tagName === 'H1') {
      const title = root.querySelector('.ss-title');
      title.replaceChildren(...Array.from(first.childNodes).map(node => node.cloneNode(true)));
      first.remove();
    }
    const sourceHeadings = Array.from(content.querySelectorAll('h1,h2,h3,h4,h5,h6'));
    const hasMajorH1 = sourceHeadings.some(el => el.tagName === 'H1');
    let insideMajorSection = false;
    sourceHeadings.forEach(el => {
      if (el.tagName === 'H1') {
        insideMajorSection = true;
        rename(el, 'h2');
      } else if (imported && hasMajorH1 && insideMajorSection && el.tagName === 'H2' && !/^medical disclaimer$/i.test(clean(el.textContent))) {
        rename(el, 'h3');
      }
    });
    if (imported) {
      const leading = Array.from(content.children).find(el => clean(el.textContent));
      if (leading && leading.tagName === 'H4') rename(leading, 'p').classList.add('ss-imported-intro');
      const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (!node.parentElement.closest('pre,code,script,style')) node.nodeValue = node.nodeValue.replace(/\u00a0/g, ' ');
      }
    }
    content.querySelectorAll('table').forEach(table => {
      if (table.parentElement.classList.contains('ss-table-scroll')) return;
      const wrap = document.createElement('div');
      wrap.className = 'ss-table-scroll';
      wrap.tabIndex = 0;
      table.before(wrap);
      wrap.append(table);
    });
    const wrapSection = (pattern, className, stopAtList) => {
      const heading = Array.from(content.children).find(el => el.tagName === 'H2' && pattern.test(clean(el.textContent)));
      if (!heading) return;
      const box = document.createElement('section');
      box.className = className;
      heading.before(box);
      let el = heading;
      while (el && (el === heading || !el.matches(stopAtList ? 'h2' : 'h2,h3'))) {
        const next = el.nextElementSibling;
        box.append(el);
        if (stopAtList && el.matches('ul,ol')) break;
        el = next;
      }
    };
    wrapSection(/^quick summary$/i, 'summary', true);
    wrapSection(/^medical disclaimer$/i, 'ss-note', false);
    const autoSplit = root.dataset.autoSplit !== 'false';
    root.querySelectorAll('.ss-title,.ss-content h2,.ss-content h3,.ss-content h4,.ss-content h5,.ss-content h6').forEach(h => formatHeading(h, autoSplit));

    const desktop = root.querySelector('.ss-toc--desktop');
    const mobile = root.querySelector('.ss-toc--mobile');
    const button = root.querySelector('.ss-mobile-toc__button');
    const icon = root.querySelector('.ss-mobile-toc__icon');
    const panel = root.querySelector('.ss-sidebar__inner');
    const bar = root.querySelector('.ss-progress__bar');
    const headings = Array.from(content.querySelectorAll('h2')).filter(h => clean(h.textContent));
    const links = [];
    const ids = new Set();
    const collapse = () => {
      mobile.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      icon.textContent = '+';
    };
    [desktop, mobile].forEach(toc => toc.replaceChildren());
    headings.forEach((heading, index) => {
      const label = clean(heading.textContent);
      const base = heading.id || label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section-' + (index + 1);
      let id = base;
      let suffix = 2;
      while (ids.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) id = base + '-' + suffix++;
      ids.add(id);
      heading.id = id;
      [desktop, mobile].forEach(toc => {
        const link = document.createElement('a');
        link.href = '#' + encodeURIComponent(id);
        link.textContent = label;
        link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (toc === mobile) collapse();
          try { history.replaceState(null, '', '#' + encodeURIComponent(id)); } catch (error) {}
          heading.setAttribute('tabindex', '-1');
          heading.focus({preventScroll: true});
          heading.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        }, {signal});
        toc.append(link);
        links.push({link, heading});
      });
    });
    root.querySelector('.ss-sidebar').hidden = !headings.length;
    root.querySelector('.ss-mobile-toc').hidden = !headings.length;
    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      mobile.hidden = expanded;
      icon.textContent = expanded ? '+' : '−';
    }, {signal});
    root.querySelector('.ss-mobile-toc').addEventListener('keydown', event => {
      if (event.key === 'Escape' && !mobile.hidden) {
        collapse();
        button.focus();
      }
    }, {signal});
    let active = null;
    const update = () => {
      frame = 0;
      const trigger = matchMedia('(max-width:749px)').matches ? 140 : 190;
      let current = headings[0];
      headings.forEach(h => { if (h.getBoundingClientRect().top <= trigger) current = h; });
      if (current && current !== active) {
        active = current;
        links.forEach(({link, heading}) => {
          const selected = heading === current;
          link.classList.toggle('is-active', selected);
          if (selected) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
          if (selected && desktop.contains(link) && panel.getClientRects().length) {
            const a = link.getBoundingClientRect();
            const b = panel.getBoundingClientRect();
            if (a.top < b.top || a.bottom > b.bottom) panel.scrollTop += a.top - b.top - 20;
          }
        });
      }
      const total = root.offsetHeight - window.innerHeight;
      const top = root.getBoundingClientRect().top;
      const ratio = total > 0 ? Math.min(1, Math.max(0, -top / total)) : (top <= 0 ? 1 : 0);
      bar.style.transform = 'scaleX(' + ratio + ')';
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, {passive: true, signal});
    window.addEventListener('resize', schedule, {signal});
    root.addEventListener('load', schedule, {capture: true, signal});
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(schedule);
      observer.observe(content);
    }
    update();
  }
  function initAll(scope) {
    if (scope.matches && scope.matches('.ss-article')) init(scope);
    scope.querySelectorAll('.ss-article').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document), {once: true});
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.ss-article').forEach(root => { if (root.ssCleanup) root.ssCleanup(); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
